import React, { useState, useMemo, useRef } from "react";
import env from "../../utils/env";
import { prepareHyHttpHeaders } from "../../utils/http";
import { createInsuranceProvidersFetcher } from "../../api/insurance-settings";

const Details = ({
  profileId,
  insurance,
  onSaveSuccess,
  onSaveError,
  components: { Label, Text, Autocomplete, Input, Button }
}) => {
  const [payerId, setPayerId] = useState(insurance.payerId ?? "");
  const [memberId, setMemberId] = useState(insurance.memberId ?? "");
  const [isConfigured, setIsConfigured] = useState(!!insurance.memberId);

  const payers = useRef([]);

  const fetchInsuranceProviders = createInsuranceProvidersFetcher;

  const fetchInsuranceProvidersWrapper = name => {
    return fetchInsuranceProviders(name)
      .then(({ data: { healthInsurancePayers } }) => {
        payers.current = healthInsurancePayers;
        return healthInsurancePayers.map(({ id, name }) => ({
          value: id,
          label: name
        }));
      })
      .catch(() => {});
  };

  const saveInsuranceInformation = data => {
    return fetch(env("BASE_HY_URL") + `profiles/${profileId}/insurance`, {
      method: "PUT",
      headers: prepareHyHttpHeaders(),
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(onSaveSuccess)
      .catch(onSaveError);
  };

  const handleSave = () => {
    const { groupId, inNetwork } = insurance;
    const payerName = payers.current.find(p => p.id === payerId).name;
    saveInsuranceInformation({
      groupId,
      inNetwork,
      memberId,
      payerId,
      payerName
    }).then(() => setIsConfigured(true));
  };

  const handleClear = () => {
    saveInsuranceInformation({
      groupId: null,
      inNetwork: false,
      memberId: "",
      payerId: "",
      payerName: ""
    }).then(() => {
      setPayerId("");
      setMemberId("");
      setIsConfigured(false);
    });
  };

  const addLabel = (text, child) => (
    <div className='search-field-wrapper-web-sdk'>
      <Label text={text} />
      {child}
    </div>
  );

  return (
    <>
      <Text>
        The Insurance Snapshot provides you with a quick view into your
        insurance deductible. Setup is quick and easy, just provide us with your
        insurer and member ID to get started. And don't worry, setup of this
        feature is not required to use the HealthiestYou service.
      </Text>
      {addLabel(
        "Insurance provider",
        <Autocomplete
          key={isConfigured}
          suggestions={[]}
          asyncFetch
          showMagnifyingGlassIcon
          showCrossIcon
          asyncFetchPromise={fetchInsuranceProvidersWrapper}
          minUserInputLength={3}
          defaultValue={
            isConfigured
              ? payers.current.find(p => p.id === payerId)?.name ||
                insurance.payerName
              : ""
          }
          handleChange={setPayerId}
          onEnterDown={setPayerId}
        />
      )}
      {addLabel(
        "Member ID",
        <Input value={memberId} onChange={e => setMemberId(e.target.value)} />
      )}
      <div className='websdk-flex'>
        <Button
          label='Save'
          className='not-in-flow websdk-mr-3'
          disabled={!payerId || !memberId}
          onClick={handleSave}
        />
        {isConfigured && (
          <Button
            label='Clear insurance details'
            className='not-in-flow secondary'
            onClick={handleClear}
          />
        )}
      </div>
    </>
  );
};

export default Details;
